"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const dayjs_1 = __importDefault(require("dayjs"));
const quarterOfYear_1 = __importDefault(require("dayjs/plugin/quarterOfYear"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const localeData_1 = __importDefault(require("dayjs/plugin/localeData"));
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(quarterOfYear_1.default);
dayjs_1.default.extend(localeData_1.default);
const useClickOutside_1 = __importDefault(require("hooks/useClickOutside"));
const HelperUtils_1 = require("utils/HelperUtils");
const DateUtils_1 = require("utils/DateUtils");
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const AntdCalendar_1 = __importDefault(require("components/shared/Calendar/AntdCalendar"));
const compact_1 = __importDefault(require("lodash/compact"));
const useFilter_1 = __importDefault(require("src/hooks/global-state/useFilter"));
const AdvanceFilter_1 = require("src/components/filter/AdvanceFilter");
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const FormatDate = (customDate, customFormatDate) => {
    const isToday = (0, isEqual_1.default)(customDate, [
        (0, dayjs_1.default)()
            .startOf('day')
            .format('YYYY-MM-DD'),
        (0, dayjs_1.default)()
            .endOf('day')
            .format('YYYY-MM-DD')
    ]);
    const isAllTime = (0, isEqual_1.default)(customDate, [null, null]);
    const isAnnual = (0, isEqual_1.default)(customDate, [
        (0, dayjs_1.default)(`${new Date().getFullYear()}-01-01`).format('YYYY-MM-DD'),
        (0, dayjs_1.default)(`${new Date().getFullYear()}-12-31`)
            .endOf('day')
            .format('YYYY-MM-DD')
    ]);
    const isNextYear = (0, isEqual_1.default)(customDate, [
        (0, dayjs_1.default)(`${new Date().getFullYear() + 1}-01-01`).format('YYYY-MM-DD'),
        (0, dayjs_1.default)(`${new Date().getFullYear() + 1}-12-31`)
            .endOf('day')
            .format('YYYY-MM-DD')
    ]);
    const isLastYear = (0, isEqual_1.default)(customDate, [
        (0, dayjs_1.default)(`${new Date().getFullYear() - 1}-01-01`).format('YYYY-MM-DD'),
        (0, dayjs_1.default)(`${new Date().getFullYear() - 1}-12-31`)
            .endOf('day')
            .format('YYYY-MM-DD')
    ]);
    if (isToday) {
        return (0, HelperUtils_1.getDateLocale)(customDate[0]);
    }
    if (isAllTime) {
        return (0, HelperUtils_1.getObjectiveLocale)('All Time');
    }
    if (isAnnual) {
        return (0, HelperUtils_1.getObjectiveLocale)(`${(0, HelperUtils_1.getObjectiveLocale)('This Year')} (${(0, dayjs_1.default)().format('YYYY')})`);
    }
    if (isLastYear) {
        return (0, HelperUtils_1.getObjectiveLocale)(`${(0, HelperUtils_1.getObjectiveLocale)('Last Year')} (${(0, dayjs_1.default)()
            .subtract(1, 'year')
            .format('YYYY')})`);
    }
    if (isNextYear) {
        return (0, HelperUtils_1.getObjectiveLocale)(`${(0, HelperUtils_1.getObjectiveLocale)('Next Year')} (${(0, dayjs_1.default)()
            .add(1, 'year')
            .format('YYYY')})`);
    }
    return ((0, HelperUtils_1.getDateLocale)(customDate[0], customFormatDate) +
        ' - ' +
        (0, HelperUtils_1.getDateLocale)(customDate[1], customFormatDate));
};
const FilterDate = ({ options, containerClassName }) => {
    var _a, _b;
    const [showDate, setShowDate] = (0, react_1.useState)(false);
    const { id } = (0, AdvanceFilter_1.useAdvanceFilter)();
    const filter = (0, useFilter_1.default)(state => state.filter);
    const setFilter = (0, useFilter_1.default)(state => state.setFilter);
    const selectedDate = [(_a = filter[id]) === null || _a === void 0 ? void 0 : _a.periodBegin, (_b = filter[id]) === null || _b === void 0 ? void 0 : _b.periodEndBefore];
    const custom = options === null || options === void 0 ? void 0 : options.includes('custom');
    const description = selectedDate[0] && selectedDate[1]
        ? FormatDate([
            (0, DateUtils_1.getDateWithForcedTimezone)(selectedDate[0]),
            (0, DateUtils_1.getDateWithForcedTimezone)(selectedDate[1])
        ], { day: 'numeric', month: 'long' })
        : (0, HelperUtils_1.getObjectiveLocale)('All Time');
    const ref = (0, react_1.useRef)(null);
    (0, useClickOutside_1.default)(ref, () => {
        setShowDate(false);
    });
    const semester = Array(2)
        .fill('')
        .map((_, index) => ({
        id: `semester_${index + 1}`,
        name: `${(0, HelperUtils_1.getObjectiveLocale)(`S${index + 1} - ${new Date().getFullYear()}`)}`,
        value: [
            (0, dayjs_1.default)()
                .month(index * 6)
                .startOf('month')
                .toISOString(),
            (0, dayjs_1.default)()
                .month((index + 1) * 6 - 1)
                .endOf('month')
                .toISOString()
        ],
        datacy: `s${index + 1}`
    }));
    const quarter = Array(4)
        .fill('')
        .map((_, index) => ({
        id: `quarter_${index + 1}`,
        name: `${(0, HelperUtils_1.getObjectiveLocale)(`Q${index + 1} - ${new Date().getFullYear()}`)}`,
        value: [
            (0, dayjs_1.default)()
                .quarter(index + 1)
                .startOf('quarter')
                .toISOString(),
            (0, dayjs_1.default)()
                .quarter(index + 1)
                .endOf('quarter')
                .toISOString()
        ],
        datacy: `q${index + 1}`
    }));
    const filterOptions = [
        {
            id: 'today',
            name: `${(0, HelperUtils_1.getObjectiveLocale)('Today')}`,
            value: [
                (0, dayjs_1.default)()
                    .startOf('day')
                    .toISOString(),
                (0, dayjs_1.default)()
                    .endOf('day')
                    .toISOString()
            ],
            datacy: 'today'
        },
        {
            id: 'all_time',
            name: `${(0, HelperUtils_1.getObjectiveLocale)('All Time')}`,
            value: [null, null],
            datacy: 'all_time'
        },
        {
            id: 'annual',
            name: `${(0, HelperUtils_1.getObjectiveLocale)(`This Year (${new Date().getFullYear().toString()})`)}`,
            value: [
                (0, dayjs_1.default)(`${new Date().getFullYear()}-01-01`).toISOString(),
                (0, dayjs_1.default)(`${new Date().getFullYear()}-12-31`)
                    .endOf('day')
                    .toISOString()
            ],
            datacy: 'annual'
        },
        {
            id: 'next_year',
            name: `${(0, HelperUtils_1.getObjectiveLocale)(`Next Year (${(new Date().getFullYear() + 1).toString()})`)}`,
            value: [
                (0, dayjs_1.default)(`${new Date().getFullYear() + 1}-01-01`).toISOString(),
                (0, dayjs_1.default)(`${new Date().getFullYear() + 1}-12-31`)
                    .endOf('day')
                    .toISOString()
            ],
            datacy: 'next_year'
        },
        {
            id: 'last_year',
            name: `${(0, HelperUtils_1.getObjectiveLocale)(`Last Year (${(new Date().getFullYear() - 1).toString()})`)}`,
            value: [
                (0, dayjs_1.default)(`${new Date().getFullYear() - 1}-01-01`).toISOString(),
                (0, dayjs_1.default)(`${new Date().getFullYear() - 1}-12-31`)
                    .endOf('day')
                    .toISOString()
            ],
            datacy: 'last_year'
        },
        ...semester,
        ...quarter
    ];
    let lists = filterOptions;
    lists = filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.filter(option => {
        var _a, _b;
        if ((options === null || options === void 0 ? void 0 : options.includes(option.id)) ||
            ((options === null || options === void 0 ? void 0 : options.includes('quarter')) && ((_a = option.id) === null || _a === void 0 ? void 0 : _a.includes('quarter'))) ||
            ((options === null || options === void 0 ? void 0 : options.includes('semester')) && ((_b = option.id) === null || _b === void 0 ? void 0 : _b.includes('semester')))) {
            return option;
        }
    });
    const selectTimeline = (timeline) => {
        var _a, _b, _c, _d;
        const date = [
            ((_a = timeline.value) === null || _a === void 0 ? void 0 : _a[0]) ? (0, dayjs_1.default)((_b = timeline.value) === null || _b === void 0 ? void 0 : _b[0]) : null,
            ((_c = timeline.value) === null || _c === void 0 ? void 0 : _c[1]) ? (0, dayjs_1.default)((_d = timeline.value) === null || _d === void 0 ? void 0 : _d[1]) : null
        ];
        handleSelectDate(date);
    };
    const handleSelectDate = (date) => {
        var _a, _b;
        const selectedDate = [
            date[0] ? (0, DateUtils_1.formatTimezone)((_a = date[0]) === null || _a === void 0 ? void 0 : _a.format('YYYY-MM-DD'), 'start') : null,
            date[1] ? (0, DateUtils_1.formatTimezone)((_b = date[1]) === null || _b === void 0 ? void 0 : _b.format('YYYY-MM-DD'), 'end') : null
        ];
        const newFilter = (0, cloneDeep_1.default)(filter[id]);
        newFilter.periodBegin = selectedDate[0];
        newFilter.periodEndBefore = selectedDate[1];
        setFilter(id, newFilter);
        setShowDate(false);
    };
    const PresetValues = () => {
        return (react_1.default.createElement(react_1.default.Fragment, null, (0, compact_1.default)(lists).map((val, index) => (react_1.default.createElement("div", { className: "px-[16px] py-[6px] cursor-pointer relative hover:bg-base-30024", "data-cy": val.datacy, key: index, onClick: () => {
                selectTimeline(val);
            } }, val.name)))));
    };
    return (react_1.default.createElement("div", { className: `filter-container ${containerClassName}` },
        react_1.default.createElement("div", { className: "content-filter" },
            react_1.default.createElement("div", { className: "time-detail bg-n-000 h-[32px] flex justify-between items-center border border-solid border-n-400 rounded-[4px]", onClick: () => setShowDate(!showDate), "data-cy": "filter-time" },
                react_1.default.createElement("p", { className: 'typography-button description', "data-cy": "date-text" }, description),
                react_1.default.createElement(SVGIcon_1.default, { size: 24, iconName: "icon-calendar_today", fillColor: "var(--base-600)" })),
            react_1.default.createElement("div", { className: "wrapper-calendar-filter", ref: ref },
                showDate && !custom && (react_1.default.createElement("div", { className: "absolute bg-n-000 z-[2] w-full border-[1px] border-solid border-n-400 mt-[8px] rounded" },
                    react_1.default.createElement(PresetValues, null))),
                showDate && custom && (
                // @ts-ignore
                react_1.default.createElement(AntdCalendar_1.default, null,
                    react_1.default.createElement(AntdCalendar_1.default.Content, { isAlwaysOpen: true, dateValue: selectedDate, leftSidebarContent: react_1.default.createElement(PresetValues, null), setDateValueHandler: handleSelectDate, clickOutsideCallback: () => setShowDate(false), position: "right" })))))));
};
exports.default = FilterDate;
